module.exports = __webpack_public_path__ + "static/media/communications.7928785d.png";